import React from 'react';
import { Shimmer, ShimmerPlaceholder } from '../../../../../../ui';
import styled from '@emotion/styled';
import {
	ItemImage,
	StyledItem,
	StyledItemArea,
	StyledItemContent,
} from '../item';
import Responsive from '../../../../../../ui/utils/Responsive';

const StyledItemShimmer = styled(Shimmer.withComponent(StyledItem))`
	svg {
		visibility: hidden;
	}

	&:hover {
		cursor: default;
	}
`;

const StyledTextShimmer = styled(ShimmerPlaceholder)`
	height: 1.2em;
`;

const StyledItemHeaderShimmer = styled(StyledTextShimmer)`
	width: 60%;
	height: 28px;
	margin-bottom: 12px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 100%;
	}
`;

const StyledAreaShimmer = styled(StyledTextShimmer)`
	width: 180px;
`;

const StyledLinkShimmer = styled(StyledTextShimmer)`
	width: 120px;
	margin-top: 10px;
`;

export const ItemShimmer = () => (
	<StyledItemShimmer>
		<ItemImage />
		<StyledItemContent>
			<div>
				<StyledItemHeaderShimmer />
				<StyledItemArea>
					<StyledAreaShimmer />
				</StyledItemArea>
			</div>
			<div>
				<StyledLinkShimmer />
			</div>
		</StyledItemContent>
	</StyledItemShimmer>
);
